/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import merge from 'lodash/merge';

import CommandEnum from '../../../command-enum';

/**
 * Komunikátor vypínacích úloh pro Ki-Wi Server
 */
class PowerTaskCommunicator {
  /**
   * @param {TimerCommunicator} timerCommunicator
   */
  constructor(timerCommunicator) {
    this.timerCommunicator = timerCommunicator;
  }

  /**
   * Zpracuje vypínací úlohu.
   * @param {Object} json Část odpovědi na obsah zařízení s jednou úlohou.
   * @param {Store} store
   * @returns {PowerTaskCommunicatorResult}
   */
  parse(json, store) {
    const { timerCommunicator } = this;
    const { daysOfWeek, id } = json;
    const powerTask = store.inject('powerTask', { id });
    const offTimerMap = timerCommunicator.parseMany(
      json.startTimes,
      id,
      CommandEnum.POWER_OFF,
      daysOfWeek
    ).timer;
    const onTimerMap = timerCommunicator.parseMany(
      json.endTimes,
      id,
      CommandEnum.POWER_ON,
      daysOfWeek
    ).timer;
    const timerArray = store.inject(
      'timer',
      Object.values(merge({}, offTimerMap, onTimerMap))
    );
    return { powerTask, timerArray };
  }
}

export default PowerTaskCommunicator;
